const extension = [
  {
    // 代理申请
    path: '/IBApplication',
    name: 'IBApplication',
    component: (resolve) => require(['@/views/generalize/IBApplication/index'], resolve),
    meta: {
      crumbsOne: 'Promote',
      crumbsTow: 'IBApplication',
      isPermission: true
    }
  },
  {
    // 推广中心
    path: '/genCenter',
    name: 'genCenter',
    component: (resolve) => require(['@/views/generalize/generalizeCenter/index'], resolve),
    meta: {
      crumbsOne: 'Promote',
      crumbsTow: 'PromotionCenter',
      isPermission: true
    }
  },
  {
    // 推广链接详情页面
    path: '/linkDetail/:id',
    name: 'linkDetail',
    component: (resolve) => require(['@/views/linkDetail/index.vue'], resolve),

    meta: {
      isShow: true,
      isHide: true,
      isPermission: false
    }
  },
  {
    // 客户列表
    path: '/clientList',
    name: 'clientList',
    component: (resolve) => require(['@/views/generalize/clientList/index'], resolve),
    meta: {
      crumbsOne: 'Promote',
      crumbsTow: 'CustomerList',
      keepAlive: true,
      isPermission: true
    }
  },
  {
    // 客户列表-查看
    path: '/clientListDetails',
    name: 'clientListDetails',
    component: (resolve) => require(['@/views/generalize/clientListDetails/index'], resolve),
    meta: {
      crumbsOne: 'Promote',
      crumbsTow: 'CustomerList'
    }
  },
  {
    // 客户交易账号数据总览
    path: '/client-account-overview',
    name: 'clientAccountOverview',
    component: (resolve) => require(['@/views/generalize/client-Account-overview/index'], resolve),
    meta: {
      crumbsOne: 'Promote',
      crumbsTow: 'clientAccountOverview',
      keepAlive: true,
      isPermission: true
    }
  },
  {
    // 客户mt资金流水
    path: '/client-mtwater',
    name: 'client-mtwater',
    component: (resolve) => require(['@/views/generalize/clientMTwater/index'], resolve),
    meta: {
      crumbsOne: 'Promote',
      crumbsTow: 'ClientMTaccountFundsflow',
      keepAlive: true,
      isPermission: true
    }
  },
  {
    // 客户交易账号-查看
    path: '/tradingDetails',
    name: 'tradingDetails',
    component: (resolve) => require(['@/views/generalize/tradingDetails/index'], resolve),
    meta: {
      crumbsOne: 'Promote',
      crumbsTow: 'CustomerTradingAccount'
    }
  },
  {
    // 我的佣金
    path: '/my-commission',
    name: 'my-commission',
    component: (resolve) => require(['@/views/generalize/myCommission/index'], resolve),
    meta: {
      crumbsOne: 'Promote',
      crumbsTow: 'MyCommission',
      keepAlive: true,
      isPermission: true
    }
  },
  {
    // 客户交易佣金报表
    path: '/client-rebate',
    name: 'client-rebate',
    component: (resolve) => require(['@/views/generalize/clientRebate/index'], resolve),
    meta: {
      crumbsOne: 'Promote',
      crumbsTow: 'ClientRabateList',
      keepAlive: true,
      isPermission: true
    }
  },
  {
    // 客户关系
    path: '/client-relations',
    name: 'client-relations',
    component: (resolve) => require(['@/views/generalize/client-relations/index'], resolve),
    meta: {
      crumbsOne: 'Promote',
      crumbsTow: 'customerRelations',
      keepAlive: true,
      isPermission: true
    }
  },
  {
    // 账户分组
    path: '/account-groups',
    name: 'account-groups',
    component: (resolve) => require(['@/views/generalize/account-groups/account-groups-index'], resolve),
    meta: {
      crumbsOne: 'Promote',
      crumbsTow: 'account-groups',
      keepAlive: true,
      isPermission: true
    }
  },
  {
    // 客户账号列表
    path: '/client-account',
    name: 'client-account',
    component: (resolve) => require(['@/views/generalize/client-Account/index'], resolve),
    meta: {
      crumbsOne: 'Promote',
      crumbsTow: 'CustomerTradingAccount',
      keepAlive: true,
      isPermission: true
    }
  },
  {
    // 客户钱包流水
    path: '/clint-walletWater',
    name: 'clint-walletWater',
    component: (resolve) => require(['@/views/generalize/clint-WalletWater/index2'], resolve),
    meta: {
      crumbsOne: 'Promote',
      crumbsTow: 'CustomerWalletFlow',
      keepAlive: true,
      isPermission: true
    }
  }
]

export default extension
